import { ActionKind, InputOutputTables, MutatingScreenKind } from "../description";
import { ActionDescriptor } from "./action-descriptor";
import { SerializedComponent } from "../../components/SerializedApp";
import { panic } from "../../Support";
import { ComponentBuilder, ComponentConfiguratorContext } from "../components";
import { BaseActionHandler, tokenForProperty } from "./base";
import { makeText } from "../builder-utils";
import { DescriptionToken } from "./action-handler";
import {
    makeLinkColumnPropertyDescriptor,
    makeOpenWebViewAction,
    OpenWebViewActionDescription,
    webViewAppearancePropertyHandler,
} from "./open-link";

export class OpenWebViewActionHandler extends BaseActionHandler<OpenWebViewActionDescription> {
    public readonly kind = ActionKind.OpenWebView;

    // FIXME: Icon
    public readonly iconName = "link";

    public getDescriptor(
        _desc: OpenWebViewActionDescription | undefined,
        _tables: InputOutputTables | undefined,
        _ccc: ComponentConfiguratorContext,
        mutatingScreenKind: MutatingScreenKind | undefined
    ): ActionDescriptor {
        return {
            name: "Open Link in Web View",
            needsScreenContext: true,
            isLegacy: true,
            properties: [makeLinkColumnPropertyDescriptor(mutatingScreenKind), webViewAppearancePropertyHandler],
        };
    }

    public makeAction(
        builder: ComponentBuilder,
        desc: OpenWebViewActionDescription,
        tables: InputOutputTables,
        screenContext: SerializedComponent | undefined
    ): SerializedComponent | undefined {
        if (screenContext === undefined) {
            return panic("Must have screen context for Open Web View action");
        }

        const url = makeText(builder, desc.link, tables.input, true, false, true, false, screenContext);
        if (url === undefined) return undefined;

        return makeOpenWebViewAction(builder.b, desc, url);
    }

    public getTokenizedDescription(
        desc: OpenWebViewActionDescription,
        tables: InputOutputTables,
        ccc: ComponentConfiguratorContext
    ): readonly DescriptionToken[] | undefined {
        const token = tokenForProperty(desc.link, tables, ccc);
        if (token === undefined) return undefined;
        return [token];
    }
}
